import { useEffect, useRef, useState } from 'react';

interface Props {
  /** ルーレットに並べる賞の名称（表示のみ。当選はサーバーが決める） */
  segments: string[];
  /** 当選した賞のインデックス。null の場合は停止位置をランダムに見せる */
  resultIndex: number | null;
  running: boolean;
  onFinished: () => void;
}

/**
 * ルーレット演出。
 *
 * 重要: 当選結果はサーバー側の抽選 API が決める。
 * この演出は「決まった結果の位置で止める」だけで、演出側では抽選しない。
 */
export function Roulette({ segments, resultIndex, running, onFinished }: Props): JSX.Element {
  const [angle, setAngle] = useState(0);
  const finishedRef = useRef(false);

  useEffect(() => {
    if (!running || finishedRef.current) return;
    finishedRef.current = true;

    const count = Math.max(segments.length, 1);
    const target = resultIndex ?? 0;
    const perSegment = 360 / count;
    // 5 回転してから当選セグメントの中央で止める
    const stopAt = 360 * 5 + (360 - (target * perSegment + perSegment / 2));
    setAngle(stopAt);

    const timer = setTimeout(onFinished, 4200);
    return () => clearTimeout(timer);
  }, [running, resultIndex, segments.length, onFinished]);

  const count = Math.max(segments.length, 1);
  const perSegment = 360 / count;
  const colors = ['#d9a441', '#8d4f66', '#c98b3a', '#6f4356', '#e0b25a', '#5b3548'];
  const gradient = segments
    .map((_, i) => {
      const color = colors[i % colors.length];
      return `${color} ${i * perSegment}deg ${(i + 1) * perSegment}deg`;
    })
    .join(', ');

  return (
    <div className="roulette" aria-label="ルーレット">
      <div className="roulette__pointer" />
      <div
        className="roulette__wheel"
        style={{
          transform: `rotate(${angle}deg)`,
          background: segments.length > 0 ? `conic-gradient(${gradient})` : '#2e2029',
        }}
      />
    </div>
  );
}
